import React, { useRef, useState } from 'react'
import Header from '../../components/global/Header'
import styles from "../../asset/css/daoPage.module.css";
import { Images } from '../../data/Images';
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { ImageComponent } from '../../components/global/ThemeImg';
export default function ApplyListPage() {
    const imgSwiperRef = useRef(null);
    const contentSwiperRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const sliderContent = [
        {
            cardTitle: "Ensure Eligibility",
            cardContent: {
                title: "Before applying, ensure your project meets the following criteria",
                lists: [
                    "Built on Solana",
                    "High-quality team and clear roadmap",
                    "Strong use case and utility",
                    "Commitment to fair launch principles (no VCs, no team allocations)",
                    "Transparent Tokenomics and security measures",
                ]
            }
        },
        {
            cardTitle: "Prepare Required Information",
            cardContent: {
                title: "You will need to provide",
                lists: [
                    "Project Name & Description: A concise overview of your project and its purpose.",
                    "Website & Socials: Official links (Twitter, Discord, Telegram, etc.)",
                    "Whitepaper & Tokenomics: A detailed document explaining your token model, distribution, and use cases.",
                    "Team Details: Background of core members and their experience.",
                    "Funding Goals: Amount you aim to raise and how funds will be allocated."
                ]
            }
        },
        {
            cardTitle: "Submit Your Application",
            cardContent: {
                title: "Submit Your Application",
                lists: [
                    "Visit Nexuslaunchpad.io and fill out the Project Listing Application Form. Ensure all details are accurate and complete."
                ]
            }
        },
        {
            cardTitle: "Review & Approval Process",
            cardContent: {
                title: "Review & Approval Process",
                lists: [
                    "The Nexus DAO will evaluate your application based on quality, legitimacy, and alignment with our standards",
                    "If selected, you will be contacted for a follow-up discussion and potential due diligence.",
                    "Approved projects will receive guidance on the next steps, including token launch strategy, marketing support, and fundraising timeline."
                ]
            }
        },
        {
            cardTitle: "Launch on Nexus",
            cardContent: {
                title: "Launch on Nexus",
                lists: [
                    "Once approved, your project will go live on Nexus Launchpad with full community support, ensuring a successful and fair launch."
                ]
            }
        }
    ]
    const handleSlideChange = (index) => {
        setActiveIndex(index);
        if (imgSwiperRef.current) imgSwiperRef.current.slideTo(index);
        if (contentSwiperRef.current) contentSwiperRef.current.slideTo(index);
    };
    return (
        <div className={`${styles.deoPage} ${styles.aiPage} ${styles.applyListPage} homePagelayout`}>
            <Header />
            <section className={styles.tokenomicsSection}>
                <div className={styles.titlePart}>
                    <h2 className={"madani_arabic_bold"}>Apply to List</h2>
                    <h3>How to Apply to List a Project on Nexus Launchpad:</h3>
                    <p>
                        Nexus Launchpad is dedicated to launching high-premium quality projects with a fair launch model on Solana. If you are a project founder looking to list your project on Nexus Launchpad, follow the steps below to apply:
                    </p>
                </div>

                <div className={styles.contentPart}>
                    <div className={styles.sliderContent}>
                        <div className={styles.applySliderBtnList}>
                            <ul>
                                {
                                    sliderContent.map((item, i) => (
                                        <li key={i}>
                                            <button className={activeIndex == i ? `${styles.active}` : ""} onClick={() => handleSlideChange(i)}>
                                                <div>
                                                    <ImageComponent themeImgSrc={`applyListIcon${i + 1}`} />
                                                </div>
                                                {item.cardTitle}
                                            </button>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                        <div className={styles.applySliderBody}>
                            <div className={styles.contentPart}>
                                <Swiper onSwiper={(swiper) => (contentSwiperRef.current = swiper)} spaceBetween={20} speed={2000} allowTouchMove={false} className="digitalSliderContent">
                                    {
                                        sliderContent.map((item, i) => (
                                            <SwiperSlide key={i} className={styles.contentSwiperSlide}>
                                                <div className={styles.cardHeader}>
                                                    <h3>{item.cardContent.title}</h3>
                                                </div>
                                                <div className={styles.cardBody}>
                                                    <ul>
                                                        {item.cardContent.lists.map((item) => (
                                                            <li>{item}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </SwiperSlide>
                                        ))
                                    }
                                </Swiper>
                            </div>
                        </div>
                    </div>
                    <div className={styles.footerPart}>
                        <p>
                            Apply today and launch with confidence on Nexus!
                        </p>
                    </div>
                </div>
                <div className={styles.tokenBgPatten}>
                    <img className={styles.aiPattenImg1} src={Images.aiPattenImg1} alt="circle Shape" />
                    <img className={styles.aiPattenImg2} src={Images.aiPattenImg2} alt="circle Shape" />
                    <img className={styles.aiPattenImg3} src={Images.aiPattenImg3} alt="circle Shape" />
                    <img className={styles.aiPattenImg4} src={Images.aiPattenImg4} alt="circle Shape" />
                    <img className={styles.aiPattenImg5} src={Images.aiPattenImg5} alt="circle Shape" />
                </div>
            </section>
        </div>
    )
}
